var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    id: "folder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9445984,14.2578777 C19.9445984,17.8360391 17.8360391,19.9445984 14.2578777,19.9445984 L6.47172553,19.9445984 C2.8844362,19.9445984 0.775876827,17.8360391 0.775876827,14.2578777 L0.775876827,6.46259757 C0.775876827,2.8844362 2.09030345,0.775876827 5.66846482,0.775876827 L7.66748864,0.775876827 C8.38576187,0.775876827 9.06211724,1.11405451 9.49308118,1.68867309 L10.4058774,2.90269213 C10.837782,3.47618249 11.5135349,3.81405896 12.23147,3.8154884 L15.0611384,3.8154884 C18.6484277,3.8154884 19.9719823,5.64108093 19.9719823,9.292266 L19.9445984,14.2578777 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.559,
    x2: 15.152,
    y1: 12.989,
    y2: 12.989
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/Catalog.e0914de809ed4762bab205977a8f8b74.svg";
export { ForwardRef as ReactComponent };